
import { defineComponent } from 'vue';
import { usePlatform } from '@/core/browser/platform.composable';
import { useSharing } from '@/core/SoMe/sharing.composable';
import { ShareNavigatorData, ShareNavigator } from '@/types/global';

export default defineComponent({
    name: 'NativeShareButton',
    props: {
        shareUrl: {
            type: String,
            required: false,
            default: '',
        },
        shareButtonText: {
            type: String,
            required: false,
            default: '',
        },
        linkTitle: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const platform = usePlatform();
        const { nativeIsSupported } = useSharing();

        let showNativeShareForCurrentOS = nativeIsSupported && (platform.ios || platform.android || platform.chromeos);
        const navigator = window.navigator as ShareNavigator;

        const share = async(data: ShareNavigatorData) => {
            if (nativeIsSupported && navigator.canShare(data)) {
                try {
                    await navigator.share(data);
                } catch (err) {
                    showNativeShareForCurrentOS = false;
                }
            }
        };

        const shareWishListLink = (): void => {
            const shareLinkData = {
                title: props.linkTitle,
                url: props.shareUrl,
            };
            share(shareLinkData);
        };

        return {
            showNativeShareForCurrentOS,
            shareWishListLink,
        };
    },
});
